/*
 * PF Comparateur — Entrée 2 (collection, pilote Gants de boxe, tous clients).
 * Cases « Comparer » sur les cartes → sélection persistée (localStorage, max 2)
 * → barre récap → récupération des produits via /products/handle?view=compare
 * (fetch same-origin avec credentials → le fragment Liquid est rendu dans le
 * contexte client : un B2B connecté reçoit prix public barré + prix club).
 * Aucun listener sur les formulaires d'achat.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('pf-cmp-config');
  var bar = document.getElementById('pf-cmp-bar');
  var barCount = document.getElementById('pf-cmp-bar-count');
  var barGo = document.getElementById('pf-cmp-bar-go');
  var barClear = document.getElementById('pf-cmp-bar-clear');
  var drawer = document.getElementById('pf-cmp-drawer');
  var tableHost = document.getElementById('pf-cmp-table');
  var store = document.getElementById('pf-cmp-store-collection');
  if (!configEl || !bar || !barGo || !drawer || !tableHost || !store) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

  var KEY = 'pf_cmp_selection';
  var MAX = 2;
  var lastFocus = null;
  // Attributs techniques (sous les pastilles et l'avis). 'stock' est cloné en
  // HTML (rendu Liquid) ; les autres en texte avec « — » si vide.
  var SPEC_ROWS = ['matiere', 'rembourrage', 'fermeture', 'tailles', 'marque', 'stock'];

  // Re-parente la barre et le drawer sur <body> : les animations du thème posent
  // des transforms transitoires sur les sections, qui re-scopent position:fixed
  // sur la section au lieu du viewport. Sur <body>, la barre reste fixe partout.
  document.body.appendChild(bar);
  document.body.appendChild(drawer);

  function getSel() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setSel(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dash(v) { return v && v.length ? esc(v) : '—'; }
  function nodeFor(h) {
    var nodes = store.querySelectorAll('.pf-cmp-data');
    for (var i = 0; i < nodes.length; i++) { if (nodes[i].getAttribute('data-handle') === h) return nodes[i]; }
    return null;
  }
  function specText(node, spec) { var el = node.querySelector('[data-spec="' + spec + '"]'); return el ? el.textContent.trim() : ''; }
  // Clone le HTML rendu par notre Liquid (pastilles, stock) — déjà échappé côté serveur.
  function specHtml(node, spec) { var el = node.querySelector('[data-spec="' + spec + '"]'); return el ? el.innerHTML.trim() : ''; }
  // Rangée de pastilles : cellule vide si le champ du produit est vide
  // (jamais de « — » sur les pastilles) ; rangée absente si les deux le sont.
  function chipsRow(label, l, r) {
    if (!l && !r) return '';
    return '<tr class="pf-cmp-rowlabel"><td colspan="2">' + esc(label) + '</td></tr>' +
           '<tr class="pf-cmp-rowvals pf-cmp-rowvals--chips"><td>' + l + '</td><td>' + r + '</td></tr>';
  }

  function headerCell(node) {
    var thumb = node.querySelector('.pf-cmp-node-thumb');
    var price = node.querySelector('.pf-cmp-node-price');
    var available = node.getAttribute('data-available') === 'true';
    var html = '<div class="pf-cmp-th">';
    html += '<div class="pf-cmp-th__thumb">' + (thumb ? thumb.innerHTML : '') + '</div>';
    if (!available) { html += '<span class="pf-cmp-badge-soldout">' + esc(config.soldOut) + '</span>'; }
    html += '<div class="pf-cmp-th__title">' + esc(node.getAttribute('data-title')) + '</div>';
    html += '<div class="pf-cmp-th__price">' + (price ? price.innerHTML : '') + '</div>';
    html += '</div>';
    return html;
  }
  function adviceCell(node) {
    var label = specText(node, 'avis-label');
    var text = specText(node, 'avis-text');
    if (!text) return '';
    return '<div class="pf-cmp-advice"><span class="pf-cmp-advice__label">' + esc(label) +
           '</span><p class="pf-cmp-advice__text">' + esc(text) + '</p></div>';
  }
  function buildTable(lh, rh) {
    var left = nodeFor(lh), right = nodeFor(rh);
    if (!left || !right) return false;
    var h = '<table class="pf-cmp-table"><thead><tr>' +
            '<th scope="col">' + headerCell(left) + '</th>' +
            '<th scope="col">' + headerCell(right) + '</th></tr></thead><tbody>';
    // 1) Pastilles de pertinence : usage puis niveau, juste sous l'en-tête.
    h += chipsRow(config.labels.usage, specHtml(left, 'usage-chips'), specHtml(right, 'usage-chips'));
    h += chipsRow(config.labels.niveau, specHtml(left, 'niveau-chip'), specHtml(right, 'niveau-chip'));
    // 2) Attributs techniques.
    SPEC_ROWS.forEach(function (spec) {
      var lv, rv;
      if (spec === 'stock') {
        lv = specHtml(left, spec) || '—';
        rv = specHtml(right, spec) || '—';
      } else {
        lv = dash(specText(left, spec));
        rv = dash(specText(right, spec));
      }
      h += '<tr class="pf-cmp-rowlabel"><td colspan="2">' + esc(config.labels[spec]) + '</td></tr>';
      h += '<tr class="pf-cmp-rowvals"><td>' + lv + '</td><td>' + rv + '</td></tr>';
    });
    // 3) Ligne d'avis (crème) : tout en bas de la colonne (amendement 4/07).
    var la = adviceCell(left), ra = adviceCell(right);
    if (la || ra) {
      h += '<tr class="pf-cmp-rowvals pf-cmp-rowvals--advice"><td>' + (la || '') + '</td><td>' + (ra || '') + '</td></tr>';
    }
    h += '<tr class="pf-cmp-rowvals pf-cmp-rowvals--cta">' +
         '<td><a class="pf-cmp-view" href="' + esc(left.getAttribute('data-url')) + '">' + esc(config.viewProduct) + '</a></td>' +
         '<td><a class="pf-cmp-view" href="' + esc(right.getAttribute('data-url')) + '">' + esc(config.viewProduct) + '</a></td></tr>';
    h += '</tbody></table>';
    tableHost.innerHTML = h;
    return true;
  }

  function focusable() { return drawer.querySelectorAll('a[href], button:not([disabled])'); }
  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusable(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('pf-cmp-open');
    document.addEventListener('keydown', onKey);
    tableHost.scrollTop = 0;
    var c = drawer.querySelector('.pf-cmp-drawer__close'); if (c) c.focus();
  }
  function closeDrawer() {
    drawer.hidden = true;
    document.body.classList.remove('pf-cmp-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function syncChecks() {
    var sel = getSel();
    Array.prototype.forEach.call(document.querySelectorAll('[data-pf-compare-check]'), function (cb) {
      cb.checked = sel.indexOf(cb.getAttribute('data-pf-handle')) > -1;
    });
    updateBar();
  }
  // Cohabitation bas d'écran : la barre de prévisualisation Shopify
  // (#PBarNextFrameWrapper) occupe le bas du viewport en recette — on
  // décale la barre de sa hauteur pour rester visible au-dessus d'elle.
  function previewBarOffset() {
    var pb = document.getElementById('PBarNextFrameWrapper');
    if (!pb) return 0;
    var h = pb.getBoundingClientRect().height;
    return h > 0 ? Math.round(h) : 0;
  }

  // Glissement d'apparition : classe éphémère, retirée en fin d'animation
  // ET par un garde-fou minuté — la position finale ne dépend jamais de
  // la progression de l'animation (moteur throttlé, onglet masqué, etc.).
  var enterTimer = null;
  function stripEnter() { bar.classList.remove('pf-cmp-bar--enter'); }
  bar.addEventListener('animationend', function (e) {
    if (e.animationName === 'pf-cmp-slide-up') stripEnter();
  });

  function updateBar() {
    var sel = getSel();
    if (!sel.length) {
      bar.hidden = true;
      stripEnter();
      document.body.classList.remove('pf-cmp-has-bar');
      return;
    }
    var wasHidden = bar.hidden;
    var off = previewBarOffset();
    bar.style.bottom = off ? off + 'px' : '';
    bar.hidden = false;
    if (wasHidden) {
      stripEnter();
      void bar.offsetWidth; // réarme l'animation
      bar.classList.add('pf-cmp-bar--enter');
      clearTimeout(enterTimer);
      enterTimer = setTimeout(stripEnter, 400);
    }
    document.body.classList.add('pf-cmp-has-bar');
    barCount.textContent = sel.length < 2 ? config.countOne : config.countTwo;
    barGo.disabled = sel.length < 2;
  }

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-pf-compare-check]');
    if (!cb) return;
    var handle = cb.getAttribute('data-pf-handle');
    var sel = getSel();
    var idx = sel.indexOf(handle);
    if (cb.checked) {
      if (idx === -1) {
        if (sel.length >= MAX) { cb.checked = false; bar.classList.add('pf-cmp-bar--full'); setTimeout(function () { bar.classList.remove('pf-cmp-bar--full'); }, 600); return; }
        sel.push(handle);
      }
    } else if (idx > -1) {
      sel.splice(idx, 1);
    }
    setSel(sel);
    updateBar();
  });

  barClear.addEventListener('click', function () { setSel([]); syncChecks(); });

  barGo.addEventListener('click', function () {
    var sel = getSel();
    if (sel.length < 2) return;
    barGo.disabled = true;
    store.innerHTML = '';
    Promise.all(sel.slice(0, 2).map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=compare', { credentials: 'include' })
        .then(function (r) { return r.ok ? r.text() : ''; });
    })).then(function (parts) {
      store.innerHTML = parts.join('');
      if (buildTable(sel[0], sel[1])) openDrawer();
      barGo.disabled = false;
    }).catch(function () { barGo.disabled = false; });
  });

  document.addEventListener('click', function (e) { if (e.target.closest('[data-pf-close]')) closeDrawer(); });

  syncChecks();
})();
